"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.supportsWasmUnsafeEval = exports.isSafariBelowVersion = exports.isIOS = exports.isSafari = void 0;
const ua_parser_js_1 = require("ua-parser-js");
const isSafari = () => Boolean(navigator.userAgent.match(/Version\/[\d.]+.*Safari/));
exports.isSafari = isSafari;
const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent) && !("MSStream" in window);
exports.isIOS = isIOS;
const isSafariBelowVersion = (version) => {
    if (!(0, exports.isSafari)())
        return false;
    const ua = navigator.userAgent;
    const safariVersion = ua.split("Version/")[1].split("Safari/")[0].trim();
    return parseInt(safariVersion) < version;
};
exports.isSafariBelowVersion = isSafariBelowVersion;
const supportsWasmUnsafeEval = () => {
    const parser = new ua_parser_js_1.UAParser();
    const os = parser.getOS().name?.toLowerCase();
    const browserName = parser.getBrowser().name?.toLowerCase();
    const browserVersion = parser.getBrowser().version;
    // < safari 16 on mac os
    if (os === "mac os" &&
        browserName === "safari" &&
        browserVersion &&
        parseInt(browserVersion) < 16) {
        return false;
    }
    // < safari 16 on iOS
    if (os === "ios" &&
        browserName === "mobile safari" &&
        browserVersion &&
        parseInt(browserVersion) < 16) {
        return false;
    }
    // < chrome "105.0.5195.147" on iOS
    // released after ios16, least chrome version supporting `wasm-unsafe-eval`
    // ignore lint for readability.
    // eslint-disable-next-line sonarjs/prefer-single-boolean-return
    if (os === "ios" &&
        browserName === "chrome" &&
        browserVersion &&
        browserVersion !== "105.0.5195.147" &&
        parseInt(browserVersion) < 106) {
        return false;
    }
    return true;
};
exports.supportsWasmUnsafeEval = supportsWasmUnsafeEval;
//# sourceMappingURL=browserUtils.js.map